import styled from '@emotion/styled';
import { Button } from '../sharedStyles';

export * from '../sharedStyles';

export const RefundButton = styled(Button)`
  display: flex;
  flex: 1;
`;

export const RefundStatus = styled.div`
  color: #f5416e;
`;

export const Title = styled.div<{ small?: boolean }>`
  display: flex;
  flex: 1;
  padding: 0 10px;
  font-size: ${({ small }) => (small ? '12px' : 'inherit')};
`;

export const Price = styled.div``;

export const OrderType = styled.div`
  font-size: 16px;
`;

export const Amount = styled.div`
  font-size: 20px;
`;

export const Vat = styled.div`
  font-size: 16px;
  color: #6a6a6a;
`;

export const Compliance = styled.div`
  font-size: 10px;
  color: #6a6a6a;
`;

export const Tip = styled.div`
  font-size: 16px;
  color: #6a6a6a;
`;
